import { useContext, useMemo } from "react";
import get from "lodash.get";
import { CascadiaJsonFormContext } from "../../CascadiaJsonFormContext";

export function useIsNewItem(path: string) {
  const { initialValues } = useContext(CascadiaJsonFormContext);
  return useMemo(() => !get(initialValues, path), [initialValues, path]);
}
